"use client"

import {
  Dialog,
  DialogContent,
  DialogDescription,
} from "@/components/ui/Dialog"

//import studentHelperGif from "./assets/student_helper_info.gif"

interface StudentHelperStudentInfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export function StudentHelperStudentInfoModal({
  isOpen,
  onClose,
}: StudentHelperStudentInfoModalProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose()
        }
      }}
    >
      <DialogContent className="!tw-max-w-5xl">
        {/* TODO: Add GIF once SH is finalied
        <img src={studentHelperGif} />*/}
        <div className="tw-flex tw-flex-col tw-items-center tw-text-center">
          <DialogDescription className="tw-text-base tw-text-gray-700">
            I'm the Student Helper! <br></br>
            Click anywhere on your assignment to select what you need help with,
            then ask me a question in the chat.
          </DialogDescription>
        </div>
      </DialogContent>
    </Dialog>
  )
}
